import React from 'react'
import { Link } from 'react-router-dom'
import { Card, Row, Col, Input, Button, Carousel, Divider, Skeleton, Empty, Spin, Collapse, Drawer, Space, Modal } from 'antd';
import { DribbbleOutlined, StopOutlined, StopFilled, DribbbleCircleFilled, SketchOutlined, CheckOutlined, SyncOutlined } from '@ant-design/icons';
import Marquee from "react-fast-marquee";
const { Panel } = Collapse;
import Slider from './Slider';
import ServerApi from '../../../utils/ServerApi';
import appConst from '../../../constents/app.const';
import api_url from '../../../utils/requestApi';

class MainContentCenter extends React.Component {
  constructor(props) {
    super(props)
    this.work_data_fetch = this.work_data_fetch.bind(this)
    this.notifications = this.notifications.bind()
  }
  state = {
    data_c: [],
    data_f: [],
    data_t: [],
    data_v: [],
    data_c_u: [],
    data_f_u: [],
    data_t_u: [],
    data_v_u: [],
    loading_c: true,
    loading_f: true,
    loading_t: true,
    loading_v: true,
    hasMore: true,
    loading: true,
    notice_l: [],
    option: [],
    loading_op: true,
    drawer: false,
    d_option: 'Option - 00.00',
    d_title: 'Actions title vs Actions title',
    d_title_id: '',
    d_sub_title: 'title sub title here',
    d_sub_title_id: '',
    d_option_title: '',
    d_option_title_id: '',
    d_option_rate: '',
    d_work_amount: '',
    d_league: 'This is league league',
    di_status: true,
    di_val: '0',
    w_loading: false,
    work_category: '0'
  }
  componentDidMount() {
    this.work_data_fetch();
    this.interval = setInterval(() => this.work_data_fetch(), 5000);
    this.notifications();
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  notifications = () => {
    const serverApi = new ServerApi(appConst.apiUrl, this.props.token)
    serverApi.club_fetch(api_url.notice, returnData => {
      if (returnData?.success == '1') {
        this.setState({ notice_l: returnData.notice })
      }
    })
  }
  work_data_fetch = () => {
    const serverApi = new ServerApi(appConst.apiUrl, null)
    serverApi.work_data(api_url.work_c_live, returnData => {
      if (returnData?.success == '1') {
        this.setState({
          loading_c: false,
          data_c: returnData.data
        })
      } else {
        this.setState({
          loading_c: true
        })
      }
    })
    serverApi.work_data(api_url.work_f_live, returnData => {
      if (returnData?.success == '1') {
        this.setState({
          loading_f: false,
          data_f: returnData.data
        })
      } else {
        this.setState({
          loading_f: true
        })
      }
    })
    serverApi.work_data(api_url.work_t_live, returnData => {
      if (returnData.success == '1') {
        this.setState({
          loading_t: false,
          data_t: returnData.data
        })
      } else {
        this.setState({
          loading_t: true
        })
      }
    })
    serverApi.work_data(api_url.work_v_live, returnData => {
      if (returnData.success == '1') {
        this.setState({
          loading_v: false,
          data_v: returnData.data,
          loading: false
        })
      } else {
        this.setState({
          loading_v: true
        })
      }
    })
    serverApi.work_data(api_url.work_c_upcoming, returnData => {
      if (returnData.success == '1') {
        this.setState({
          data_c_u: returnData.data
        })
      } else {
        this.setState({
          data_c_u: []
        })
      }
    })
    serverApi.work_data(api_url.work_f_upcoming, returnData => {
      if (returnData.success == '1') {
        this.setState({
          data_f_u: returnData.data
        })
      } else {
        this.setState({
          data_f_u: []
        })
      }
    })
    serverApi.work_data(api_url.work_t_upcoming, returnData => {
      if (returnData.success == '1') {
        this.setState({
          data_t_u: returnData.data
        })
      } else {
        this.setState({
          data_t_u: []
        })
      }
    })
    serverApi.work_data(api_url.work_v_upcoming, returnData => {
      if (returnData.success == '1') {
        this.setState({
          data_v_u: returnData.data,
        })
      } else {
        this.setState({
          data_v_u: []
        })
      }
    })
  }
  empty_work = (
    <Card size="small">
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        imageStyle={{ height: '40px' }}
        description="Empty Match"
      />
    </Card>
  )
  work_submit_action = (e) => {
    this.setState({ d_work_amount: Number(e.target.innerHTML) }, () => {
      document.getElementById('work-actual-input').value = e.target.innerHTML
    })
  }
  work_final_submit = () => {
    const api_routeee = (this.state.work_category == 'CB1' || this.state.work_category == 'CB2') ? api_url.work_total : (this.state.work_category == 'CC1' || this.state.work_category == 'CC2') ? api_url.work_per : api_url.work_regular;
    const serverApi = new ServerApi(appConst.apiUrl, this.props.token);
    serverApi.work_actions(api_routeee, 'POST', this.state, returnData => {
      if (returnData.success == '1') {
        //this.props.onMyAccount();
        Modal.success({ title: returnData.message })
        this.setState({ w_loading: false, drawer: false });
        setTimeout(() => {
          window.location.reload();
        }, 500);
      } else {
        this.setState({ w_loading: false })
        Modal.error({ title: returnData.message })
        if (returnData.message == 'Rate changed. Try again') {
          this.setState({ drawer: false })
        }
      }
    })
  }
  handleDownloadApp = () => {
    const link = document.createElement('a');
    link.href = 'https://boss90.live/boss90.apk';
    link.download = 'boss90.apk';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  render() {
    const onChange = (currentSlide) => {
      //console.log(currentSlide);
    }
    return (
      <Spin tip="Live..." spinning={this.state.loading} size="large" style={{ color: 'black', fontSize: '15px', fontWeight: 'bold' }}>
        <div style={{ marginBottom: '3px', }}>
          {(this.state.drawer == true) ? (
            <div
              style={{
                position: "fixed",
                bottom: "120px",
                right: "10px",
                width: "330px",
                height: "350px",

                borderRadius: "12px",
                boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
                backgroundColor: "#134A41",
                zIndex: 1000,
                padding: "25px",
                overflowY: "auto",
                display: this.state.drawer ? "block" : "none",
                border: "1px solid #e8e8e8",
              }}
            >
              {/* Close Button */}
              <div
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  cursor: "pointer",
                  fontSize: "18px",
                  color: "#6F6F6E",
                }}
                onClick={() => this.setState({ drawer: false })}
              >
                ×
              </div>

              <Spin spinning={this.state.w_loading} size="small">

                <div>
                  <span style={{ fontSize: "18px", color: "#fff", fontWeight: "700", display: "block", marginBottom: "12px" }}>
                    {this.state.d_title}
                  </span>
                  <span style={{ fontSize: "16px", color: "#FFDAB9", display: "flex", fontWeight: "500", marginBottom: "10px" }}>
                    {this.state.d_sub_title}
                  </span>
                </div>

                {/* Select option */}
                <div>
                  <span style={{ color: "#84D09C", fontSize: "17px" }}>Select</span>
                  <span style={{ fontSize: "17px", color: "#fff", marginLeft: "8px", fontWeight: "350" }}>{this.state.d_option}</span>
                </div>

                {/* Input */}
                <Space wrap style={{
                  marginTop: "10px",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",


                }}>
                  <Button
                    type="primary"
                    ghost
                    onClick={() => this.setState({ d_work_amount: 500 })}
                    style={{ fontSize: "14px", padding: "0px 5px 0px 5px", color: "#fff" }}


                  >
                    500
                  </Button>
                  <Button
                    type="primary"
                    ghost
                    onClick={() => this.setState({ d_work_amount: 1000 })}
                    style={{ fontSize: "14px", padding: "0px 5px 0px 5px", color: "#fff" }}
                  >
                    1000
                  </Button>
                  <Button
                    type="primary"
                    ghost
                    onClick={() => this.setState({ d_work_amount: 2000 })}
                    style={{ fontSize: "14px", padding: "0px 5px 0px 5px", color: "#fff" }}
                  >
                    2000
                  </Button>
                  {(this.state.work_category === "CB1" ||
                    this.state.work_category === "CB2" ||
                    this.state.work_category === "CC1" ||
                    this.state.work_category === "CC2") && (
                      <Button
                        type="primary"
                        ghost
                        onClick={() => this.setState({ d_work_amount: 2500 })}
                        style={{ fontSize: "14px", padding: "0px 5px 0px 5px", color: "#fff" }}
                      >
                        2500
                      </Button>
                    )}
                  <Button
                    type="primary"
                    ghost
                    onClick={() => this.setState({ d_work_amount: 3000 })}
                    style={{ fontSize: "14px", padding: "0px 5px 0px 5px", color: "#fff" }}
                  >
                    3000
                  </Button>
                  {(this.state.work_category !== "CB1" &&
                    this.state.work_category !== "CB2" &&
                    this.state.work_category !== "CC1" &&
                    this.state.work_category !== "CC2") && (
                      <Button
                        type="primary"
                        ghost
                        onClick={() => this.setState({ d_work_amount: 5000 })}
                        style={{ fontSize: "14px", padding: "0px 5px 0px 5px", color: "#fff" }}
                      >
                        5000
                      </Button>
                    )}
                </Space>
                <Input
                  type="number"
                  value={this.state.d_work_amount}
                  id="work-actual-input"
                  onChange={(e) => this.setState({ d_work_amount: Number(e.target.value) || 0 })}
                  style={{
                    width: "100%",

                    fontSize: "16px",
                    textAlign: "center",
                    border: "1px solid #e8e8e8",
                    borderRadius: "8px",
                    marginTop: "16px",
                    backgroundColor: "#fafafa",
                    color: "#333",
                  }}
                  placeholder="Enter amount"
                />


                <div style={{ marginTop: "10px" }}>

                  <span style={{ color: "#84D09C", fontSize: "14px", fontWeight: "500" }}>Rate</span>
                  <b style={{ fontSize: "18px", color: "#fff", marginLeft: "8px" }}>{this.state.d_option_rate}</b>
                </div>

                <div>
                  <span style={{ color: "#84D09C", fontSize: "14px", fontWeight: "500" }}>Woning Amount</span>
                  <b style={{ fontSize: "18px", color: "#fff", marginLeft: "8px" }}>
                    {(Number(this.state.d_option_rate) * Number(this.state.d_work_amount || 0)).toFixed(2)}
                  </b>


                </div>




                <Button
                  type="primary"
                  block
                  icon={<SketchOutlined />}
                  onClick={() => {
                    if (!this.state.d_work_amount || this.state.d_work_amount === 0) {
                      Modal.error({ title: "Please enter or select an amount!" });
                      return;
                    }
                    this.setState({ w_loading: true });
                    setTimeout(this.work_final_submit, 100);
                  }}
                  loading={this.state.w_loading}
                  style={{
                    background: "#134837",
                    color: "#fff",
                    border: "none",
                    fontWeight: "600",
                    marginTop: "16px",
                    borderRadius: "8px",
                    height: "40px",
                    fontSize: "16px",
                  }}
                >
                  Submit
                </Button>
              </Spin>
            </div>
          ) : ''}
          {/* <Carousel
            afterChange={onChange}
            autoplay
            effect="fade"
            autoplaySpeed={3000}
            dots={false}

          >
            {this.state.notice_l.map((notice, index) => (
              <div key={index} style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "60px", padding: "10px 15px" }}>
                <div
                  style={{

                    fontWeight: "600",
                    textAlign: "center",



                    transition: "transform 0.3s ease-in-out",
                  }}
                  dangerouslySetInnerHTML={{ __html: notice.text }}
                ></div>
              </div>
            ))}
          </Carousel>
          */}
          <Marquee gradient={false} speed={50}>
            {this.state.notice_l.map((notice, index) => (
              <div key={index} style={{ display: "flex", }}>
                <div
                  style={{

                    fontWeight: "600",
                    textAlign: "center",
                    marginTop: "10px",
                    transition: "transform 0.3s ease-in-out",
                  }}
                  dangerouslySetInnerHTML={{ __html: notice.text }}
                ></div>
              </div>
            ))}
          </Marquee>


          {/* <Slider /> */}
          <div className="after-ant-anchor-header-div">
            {this.state.loading_c == false ? (
              <>

                {this.state.data_c.length > 0 ? this.state.data_c.map((work, index) => {
                  return (
                    <div key={index}>
                      <Link to={"/pot single page?id=" + work.id + "&type=c_work"}>
                        <Card hoverable={true} size="small" className="" style={{ backgroundColor: "#778B84" }}>
                          <Row >
                            <Col span={2}><img className="logo-title-m" src="./img/game/cricket1.png" width="30" /></Col>
                            <Col span={21}>
                              <span style={{ fontSize: '16px' }}><span>{work.team1 + ' '}</span><span className="title-vs">vs</span><span>{' ' + work.team2}</span></span><br />
                              <span style={{ fontSize: '12px' }}>{work.title + ' || ' + work.date}</span>
                            </Col>
                          </Row>
                        </Card>
                      </Link>
                      {work.sub_title ? work.sub_title.length > 0 ? work.sub_title.map((sub_title, index) => {
                        let sub_title_name = (sub_title.over != 0 ? (sub_title.over + (sub_title.category.substring(0, 2) == 'CC' ? (sub_title.over == 1 ? 'st ' : sub_title.over == 2 ? 'nd ' : sub_title.over == 3 ? 'rd ' : 'th ') : ' ')) : '') + sub_title.sub_title;
                        return (
                          <div key={index} className="pot-single-div-sub">

                            <div
                              className="pot-single-div-sub-collapse"
                            // activeKey={sub_title.active==0?[]:['1']}
                            >
                              <div

                              >
                                {/*cricket title*/}
                                <div style={{ color: "#000001", padding: "7px 0px 7px 15px", fontWeight: "700" }}>{sub_title_name}</div>
                                <Row>
                                  {(JSON.parse(sub_title.optionn).length > 0 && sub_title.active == 1) ? JSON.parse(sub_title.optionn).map((option, i) => {
                                    let option_name = option.autoNo ?
                                      (option.autoNo == 0) ? option.title
                                        : (option.autoNo == 5 || (option.autoNo == 6 && option.under == 4) || (option.autoNo == 2 && (option.under == 6 || option.under == 5)) || (option.autoNo == 3 && option.under == 7)) ? Math.trunc(option.run) + ' ' + option.title + ' ' + Math.trunc(option.run2)
                                          : ((option.autoNo == 3 && option.under == 8) || (option.autoNo == 7 && option.under == 1)) ? Math.trunc(option.run) + ' ' + (sub_title.category.substring(0, 2) == 'CB' ? 'or +' : option.title)
                                            : option.run + ' ' + option.title
                                      : option.title
                                    let title_name = (work.team1 ? work.team1 : 'Team A') + ' vs ' + (work.team2 ? work.team2 : 'Team B');
                                    return (
                                      <Col
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={12}
                                        key={i}
                                      >
                                        <div
                                          style={{
                                            padding: "3px",
                                            backgroundColor: "#185C43",
                                            color: "#fff",
                                            borderRadius: "4px",
                                            marginLeft: "15px",
                                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            transition: "background-color 0.3s ease, transform 0.2s ease",
                                          }}
                                          onClick={(e) => {
                                            this.setState({
                                              drawer: true,
                                              d_option: option_name,
                                              d_sub_title: sub_title_name,
                                              d_title: title_name,
                                              d_league: work.title ? work.title : "",
                                              d_title_id: work.id,
                                              d_sub_title_id: sub_title.id,
                                              d_option_title: option.title,
                                              d_option_title_id: option.id,
                                              d_option_rate: (Number(option.rate) * 1.0).toFixed(2),
                                              work_category: sub_title.category,
                                            });
                                          }}
                                          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#E5E7EB")}
                                          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#185C43")}
                                        >
                                          {/* cricket main text and rate*/}
                                          <span style={{ fontWeight: "600", fontSize: "14px" }}>{option_name}</span>
                                          <span
                                            style={{
                                              backgroundColor: "#134837",
                                              color: "#fff",
                                              padding: "5px 15px",
                                              borderRadius: "5px",
                                              fontWeight: "600",
                                              fontSize: "14px",
                                            }}
                                          >
                                            {(Number(option.rate) * 1.0).toFixed(2)}
                                          </span>
                                        </div>

                                      </Col>
                                    )
                                  }) : ''}
                                </Row>
                              </div>
                            </div>
                          </div>
                        )
                      }) : '' : ''}
                    </div>
                  )
                }) : ''}
              </>
            ) : (
              <>
                <Card hoverable={true} bordered={true}>
                  <Skeleton active />
                </Card>
                <Card hoverable={true} bordered={true}>
                  <Skeleton active />
                </Card>
              </>
            )}
            {this.state.loading_f == false ? (
              <>
                {/* Football - Live  */}
                {this.state.data_f.length > 0 ? this.state.data_f.map((work, index) => {
                  return (
                    <div key={index}>
                      <Link to={"/pot single page?id=" + work.id + "&type=f_work"}>
                        <Card hoverable={true} bordered={true} size="small" style={{ backgroundColor: "#778B84" }}>
                          <Row>
                            <Col span={3}><img className="logo-title-m" src="./img/game/football.png" width="30" /></Col>
                            <Col span={21}>
                              <span style={{ fontSize: '16px' }}><span>{work.team1 + ' '}</span><span className="title-vs">vs</span><span>{' ' + work.team2}</span></span><br />
                              <span style={{ fontSize: '12px' }}>{work.title + ' || ' + work.date}</span>
                            </Col>
                          </Row>
                        </Card>
                      </Link>
                      {work.sub_title ? work.sub_title.length > 0 ? work.sub_title.map((sub_title, index) => {
                        let sub_title_name = (sub_title.over != 0 ? (sub_title.over + (sub_title.category.substring(0, 2) == 'CC' ? (sub_title.over == 1 ? 'st ' : sub_title.over == 2 ? 'nd ' : sub_title.over == 3 ? 'rd ' : 'th ') : ' ')) : '') + sub_title.sub_title;
                        return (
                          <div key={index}>

                            <div style={{ color: "#000001", padding: "7px 0px 7px 15px", fontWeight: "700" }}>{sub_title_name}</div>
                            <Row >
                              {(JSON.parse(sub_title.optionn).length > 0 && sub_title.active == 1) ? JSON.parse(sub_title.optionn).map((option, i) => {
                                let option_name = option.autoNo ?
                                  (option.autoNo == 0) ? option.title
                                    : (option.autoNo == 5 || (option.autoNo == 6 && option.under == 4) || (option.autoNo == 2 && (option.under == 6 || option.under == 5)) || (option.autoNo == 3 && option.under == 7)) ? Math.trunc(option.run) + ' ' + option.title + ' ' + Math.trunc(option.run2)
                                      : ((option.autoNo == 3 && option.under == 8) || (option.autoNo == 7 && option.under == 1)) ? Math.trunc(option.run) + ' ' + (sub_title.category.substring(0, 2) == 'CB' ? 'or +' : option.title)
                                        : option.run + ' ' + option.title
                                  : option.title
                                let title_name = (work.team1 ? work.team1 : 'Team A') + ' vs ' + (work.team2 ? work.team2 : 'Team B');
                                return (
                                  <Col
                                    xs={JSON.parse(sub_title.optionn).length == 2 ? 12 : 12}
                                    sm={JSON.parse(sub_title.optionn).length == 2 ? 12 : 12}
                                    md={JSON.parse(sub_title.optionn).length == 2 ? 12 : 12}
                                    lg={JSON.parse(sub_title.optionn).length == 2 ? 12 : 12}
                                    xl={JSON.parse(sub_title.optionn).length == 2 ? 12 : 12}
                                    key={i}
                                  >
                                    <div
                                      style={{
                                        padding: "3px",
                                        backgroundColor: "#185C43",
                                        color: "#fff",
                                        borderRadius: "4px",
                                        marginLeft: "15px",
                                        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        transition: "background-color 0.3s ease, transform 0.2s ease",
                                      }}
                                      size="small"
                                      hoverable={true}

                                      onClick={(e) => {
                                        this.setState({
                                          drawer: true,
                                          d_option: option_name,
                                          d_sub_title: sub_title_name,
                                          d_title: title_name,
                                          d_league: work.title ? work.title : '',
                                          d_title_id: work.id,
                                          d_sub_title_id: sub_title.id,
                                          d_option_title: option.title,
                                          d_option_title_id: option.id,
                                          d_option_rate: option.rate,
                                          work_category: sub_title.category
                                        })
                                      }}
                                    >
                                      <span style={{ fontWeight: "600", fontSize: "16px" }}>{option_name}</span>  <span
                                        style={{
                                          backgroundColor: "#134837",
                                          color: "#fff",
                                          padding: "5px 15px",
                                          borderRadius: "5px",
                                          fontWeight: "600",
                                          fontSize: "14px",
                                        }}
                                      >{Number(option.rate).toFixed(2)}</span></div>

                                  </Col>
                                )
                              }) : ''}
                            </Row>
                          </div>

                        )
                      }) : '' : ''}
                    </div>
                  )
                }) : ''}
              </>
            ) : (
              <>
                <Card hoverable={true} bordered={true}>
                  <Skeleton active />
                </Card>
                <Card hoverable={true} bordered={true}>
                  <Skeleton active />
                </Card>
              </>
            )}
            {this.state.loading_t == false ? (
              <>


                {/*  Tennis Main Section  - Live */}
                {this.state.data_t.length > 0 ? this.state.data_t.map((work, index) => {
                  return (
                    <div key={index}>
                      <Link to={"/pot single page?id=" + work.id + "&type=t_work"}>
                        <Card hoverable={true} bordered={true} size="small" style={{ backgroundColor: "#778B84" }}>
                          <Row>
                            <Col span={3}><img className="logo-title-m" src="./img/game/tennis.png" width="30" /></Col>
                            <Col span={21}>
                              <span style={{ fontSize: '16px' }}><span>{work.team1 + ' '}</span><span className="title-vs">vs</span><span>{' ' + work.team2}</span></span><br />
                              <span style={{ fontSize: '12px' }}>{work.title + ' || ' + work.date}</span>
                            </Col>
                          </Row>
                        </Card>
                      </Link>
                      {work.sub_title ? work.sub_title.length > 0 ? work.sub_title.map((sub_title, index) => {
                        let sub_title_name = (sub_title.over != 0 ? (sub_title.over + (sub_title.category.substring(0, 2) == 'CC' ? (sub_title.over == 1 ? 'st ' : sub_title.over == 2 ? 'nd ' : sub_title.over == 3 ? 'rd ' : 'th ') : ' ')) : '') + sub_title.sub_title;
                        return (
                          <div key={index} className="pot-single-div-sub">

                            {/* Tennis title */}
                            <div style={{ color: "#000001", padding: "7px 0px 7px 15px", fontWeight: "700" }}>{sub_title_name}</div>
                            <Row>
                              {(JSON.parse(sub_title.optionn).length > 0 && sub_title.active == 1) ? JSON.parse(sub_title.optionn).map((option, i) => {
                                let option_name = option.autoNo ?
                                  (option.autoNo == 0) ? option.title
                                    : (option.autoNo == 5 || (option.autoNo == 6 && option.under == 4) || (option.autoNo == 2 && (option.under == 6 || option.under == 5)) || (option.autoNo == 3 && option.under == 7)) ? Math.trunc(option.run) + ' ' + option.title + ' ' + Math.trunc(option.run2)
                                      : ((option.autoNo == 3 && option.under == 8) || (option.autoNo == 7 && option.under == 1)) ? Math.trunc(option.run) + ' ' + (sub_title.category.substring(0, 2) == 'CB' ? 'or +' : option.title)
                                        : option.run + ' ' + option.title
                                  : option.title
                                let title_name = (work.team1 ? work.team1 : 'Team A') + ' vs ' + (work.team2 ? work.team2 : 'Team B');
                                return (
                                  <Col
                                    xs={JSON.parse(sub_title.optionn).length == 2 ? 12 : 12}
                                    sm={JSON.parse(sub_title.optionn).length == 2 ? 12 : 12}
                                    md={JSON.parse(sub_title.optionn).length == 2 ? 12 : 12}
                                    lg={JSON.parse(sub_title.optionn).length == 2 ? 12 : 12}
                                    xl={JSON.parse(sub_title.optionn).length == 2 ? 12 : 12}
                                    // className="p-0"
                                    key={i}
                                  >
                                    {/* Tennis option */}
                                    <div
                                      style={{
                                        padding: "3px",
                                        backgroundColor: "#185C43",
                                        borderRadius: "4px",
                                        color: "#fff",
                                        marginLeft: "15px",
                                        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        transition: "background-color 0.3s ease, transform 0.2s ease",
                                      }}

                                      size="small"
                                      hoverable={true}
                                      onClick={(e) => {
                                        this.setState({
                                          drawer: true,
                                          d_option: option_name,
                                          d_sub_title: sub_title_name,
                                          d_title: title_name,
                                          d_league: work.title ? work.title : '',
                                          d_title_id: work.id,
                                          d_sub_title_id: sub_title.id,
                                          d_option_title: option.title,
                                          d_option_title_id: option.id,
                                          d_option_rate: option.rate,
                                          work_category: sub_title.category
                                        })
                                      }}
                                    >
                                      {/* Tennis rate and text */}
                                      <span style={{ fontWeight: "600", fontSize: "16px" }}>{option_name}</span>  <span
                                        style={{
                                          backgroundColor: "#134837",
                                          color: "#fff",
                                          padding: "5px 15px",
                                          borderRadius: "5px",
                                          fontWeight: "600",
                                          fontSize: "14px",
                                        }}
                                      >{Number(option.rate).toFixed(2)}</span></div>

                                  </Col>
                                )
                              }) : ''}
                            </Row>
                          </div>

                        )
                      }) : '' : ''}
                    </div>
                  )
                }) : ''}
              </>
            ) : (
              <>
                <Card hoverable={true} bordered={true}>
                  <Skeleton active />
                </Card>
                <Card hoverable={true} bordered={true}>
                  <Skeleton active />
                </Card>
              </>
            )}
            {this.state.loading_v == false ? (
              <>


                {/*  Table Tannis - Live  Main Section*/}
                {this.state.data_v.length > 0 ? this.state.data_v.map((work, index) => {
                  return (
                    <div key={index}>
                      <Link to={"/pot single page?id=" + work.id + "&type=v_work"}>
                        <Card hoverable={true} bordered={true} size="small" style={{ backgroundColor: "#778B84" }}>
                          <Row>
                            <Col span={3}><img className="logo-title-m" src="./img/game/table_tennis.png" width="30" /></Col>
                            <Col span={21}>
                              <span style={{ fontSize: '16px' }}><span>{work.team1 + ' '}</span><span className="title-vs">vs</span><span>{' ' + work.team2}</span></span><br />
                              <span style={{ fontSize: '12px' }}>{work.title + ' || ' + work.date}</span>
                            </Col>
                          </Row>
                        </Card>
                      </Link>
                      {work.sub_title ? work.sub_title.length > 0 ? work.sub_title.map((sub_title, index) => {
                        let sub_title_name = (sub_title.over != 0 ? (sub_title.over + (sub_title.category.substring(0, 2) == 'CC' ? (sub_title.over == 1 ? 'st ' : sub_title.over == 2 ? 'nd ' : sub_title.over == 3 ? 'rd ' : 'th ') : ' ')) : '') + sub_title.sub_title;
                        return (
                          <div key={index} >
                            <div
                              className="pot-single-div-sub-collapse"
                            >
                              <div
                               
                              >
                                {/*table tenish title*/}
                                <div style={{ backgroundColor: "#fff", color: "#000001", padding: "7px 0px 7px 15px", fontWeight: "700" }}>{sub_title_name}</div>
                                <Row >
                                  {(JSON.parse(sub_title.optionn).length > 0 && sub_title.active == 1) ? JSON.parse(sub_title.optionn).map((option, i) => {
                                    let option_name = option.autoNo ?
                                      (option.autoNo == 0) ? option.title
                                        : (option.autoNo == 5 || (option.autoNo == 6 && option.under == 4) || (option.autoNo == 2 && (option.under == 6 || option.under == 5)) || (option.autoNo == 3 && option.under == 7)) ? Math.trunc(option.run) + ' ' + option.title + ' ' + Math.trunc(option.run2)
                                          : ((option.autoNo == 3 && option.under == 8) || (option.autoNo == 7 && option.under == 1)) ? Math.trunc(option.run) + ' ' + (sub_title.category.substring(0, 2) == 'CB' ? 'or +' : option.title)
                                            : option.run + ' ' + option.title
                                      : option.title
                                    let title_name = (work.team1 ? work.team1 : 'Team A') + ' vs ' + (work.team2 ? work.team2 : 'Team B');
                                    return (
                                      <Col
                                        xs={JSON.parse(sub_title.optionn).length == 2 ? 12 : 12}
                                        sm={JSON.parse(sub_title.optionn).length == 2 ? 12 : 12}
                                        md={JSON.parse(sub_title.optionn).length == 2 ? 12 : 12}
                                        lg={JSON.parse(sub_title.optionn).length == 2 ? 12 : 12}
                                        xl={JSON.parse(sub_title.optionn).length == 2 ? 12 : 12}
                                        // className="p-0"
                                        key={i}
                                      >

                                        <div
                                          // table tenis option 
                                          style={{
                                            padding: "3px",
                                            backgroundColor: "#185C43",
                                            borderRadius: "4px",
                                            color: "#fff",
                                            marginLeft: "15px",
                                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            transition: "background-color 0.3s ease, transform 0.2s ease",
                                          }}

                                          hoverable={true}
                                          onClick={(e) => {
                                            this.setState({
                                              drawer: true,
                                              d_option: option_name,
                                              d_sub_title: sub_title_name,
                                              d_title: title_name,
                                              d_league: work.title ? work.title : '',
                                              d_title_id: work.id,
                                              d_sub_title_id: sub_title.id,
                                              d_option_title: option.title,
                                              d_option_title_id: option.id,
                                              d_option_rate: option.rate,
                                              work_category: sub_title.category
                                            })
                                          }}
                                        >
                                          {/*table tenis rate and text section */}
                                          <span style={{ fontWeight: "600", fontSize: "16px" }}>{option_name}</span>  <span style={{
                                            backgroundColor: "#134837",
                                            color: "#fff",
                                            padding: "5px 15px",
                                            borderRadius: "5px",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                          }}>{Number(option.rate).toFixed(2)}</span></div>

                                      </Col>
                                    )
                                  }) : ''}
                                </Row>
                              </div>
                            </div>
                          </div>
                        )
                      }) : '' : ''}
                    </div>
                  )
                }) : ''}
              </>
            ) : (
              <>
                <Card hoverable={true} bordered={true}>
                  <Skeleton active />
                </Card>
                <Card hoverable={true} bordered={true}>
                  <Skeleton active />
                </Card>
              </>
            )}
            {/* Upcoming Main Section */}
            <Divider orientation="center" dashed style={{ height: '10px', fontSize: '13px', fontWeight: 'bold', color: "#1F1F1F" }}><SyncOutlined /> Upcoming</Divider>
            {this.state.data_c_u.length > 0 ? this.state.data_c_u.map((work, index) => {
              return (
                <div key={index}>
                  <Link to={"/pot single page?id=" + work.id + "&type=c_work"}>
                    <Card style={{ backgroundColor: "#778B84" }} hoverable={true} bordered={true} size="small" >
                      <Row>
                        <Col span={3}><img className="logo-title-m" src="./img/game/cricket.png" width="30" /></Col>
                        <Col span={21}>
                          <span style={{ fontSize: '16px' }}><span>{work.team1 + ' '}</span><span className="title-vs">vs</span><span>{' ' + work.team2}</span></span><br />
                          <span style={{ fontSize: '12px' }}>{work.title + ' || ' + work.date}</span>
                        </Col>
                      </Row>
                    </Card>
                  </Link>
                </div>
              )
            }) : ''}
            {this.state.data_f_u.length > 0 ? this.state.data_f_u.map((work, index) => {
              return (
                <div key={index}>
                  <Link to={"/pot single page?id=" + work.id + "&type=c_work"}>
                    <Card style={{ backgroundColor: "#778B84" }} hoverable={true} bordered={true} size="small" >
                      <Row>
                        <Col span={3}><img className="logo-title-m" src="./img/game/football.png" width="30" /></Col>
                        <Col span={21}>
                          <span style={{ fontSize: '16px' }}><span>{work.team1 + ' '}</span><span className="title-vs">vs</span><span>{' ' + work.team2}</span></span><br />
                          <span style={{ fontSize: '12px' }}>{work.title + ' || ' + work.date}</span>
                        </Col>
                      </Row>
                    </Card>
                  </Link>
                </div>
              )
            }) : ''}
            {this.state.data_t_u.length > 0 ? this.state.data_t_u.map((work, index) => {
              return (
                <div key={index}>
                  <Link to={"/pot single page?id=" + work.id + "&type=c_work"}>
                    <Card style={{ backgroundColor: "#778B84" }} hoverable={true} bordered={true} size="small">
                      <Row>
                        <Col span={3}><img className="logo-title-m" src="./img/game/tennis.png" width="30" /></Col>
                        <Col span={21}>
                          <span style={{ fontSize: '16px' }}><span>{work.team1 + ' '}</span><span className="title-vs">vs</span><span>{' ' + work.team2}</span></span><br />
                          <span style={{ fontSize: '12px' }}>{work.title + ' || ' + work.date}</span>
                        </Col>
                      </Row>
                    </Card>
                  </Link>
                </div>
              )
            }) : ''}
            {this.state.data_v_u.length > 0 ? this.state.data_v_u.map((work, index) => {
              return (
                <div key={index}>
                  <Link to={"/pot single page?id=" + work.id + "&type=c_work"}>
                    <Card style={{ backgroundColor: "#778B84" }} hoverable={true} bordered={true} size="small" >
                      <Row>
                        <Col span={3}><img className="logo-title-m" src="./img/game/table_tennis.png" width="30" /></Col>
                        <Col span={21}>
                          <span style={{ fontSize: '16px' }}><span>{work.team1 + ' '}</span><span className="title-vs">vs</span><span>{' ' + work.team2}</span></span><br />
                          <span style={{ fontSize: '12px' }}>{work.title + ' || ' + work.date}</span>
                        </Col>
                      </Row>
                    </Card>
                  </Link>
                </div>
              )
            }) : ''}
          </div>
        </div>
      </Spin>
    );
  }
}

export default MainContentCenter;